import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rename-client-dialog',
  templateUrl: './rename-client-dialog.component.html',
  styleUrls: ['./rename-client-dialog.component.scss']
})
export class RenameClientDialogComponent {
  private _currentName = '';
  newName = '';

  // Set by the opener through modalRef.componentInstance before first change detection
  @Input() set currentName(value: string) {
    this._currentName = value;
    this.newName = value;
  }
  get currentName(): string {
    return this._currentName;
  }

  constructor(public activeModal: NgbActiveModal) {}

  get canSave(): boolean {
    const trimmed = this.newName.trim();
    return trimmed.length > 0 && trimmed !== this._currentName;
  }

  save(): void {
    if (this.canSave) {
      this.activeModal.close(this.newName.trim());
    }
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
